import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Artigo from "../pages/artigo/page";
import ArtigoDetalhe from "../pages/artigo-detalhe/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo-cssbuyspreadsheet-guia-completo-2026",
    element: <Artigo />,
  },
  {
    path: "/artigo/:slug",
    element: <ArtigoDetalhe />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;